import { render, staticRenderFns } from "./ClientCard.vue?vue&type=template&id=7b73f761&scoped=true"
import script from "./ClientCard.vue?vue&type=script&lang=js"
export * from "./ClientCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b73f761",
  null
  
)

export default component.exports